import _ from 'lodash';
import React from 'react';
import rawMarkup from '../../util/rawMarkup';
import pageTrackingConfig from '../../config/pageTracking';
import config from '../../config';

const { CONFIG_PROFILE } = config;

// This should be locate just before GoogleAnalyticsScript
export default class GooglePageHiding extends React.PureComponent {
  render() {
    const env = CONFIG_PROFILE === 'prod' || CONFIG_PROFILE === 'special'
      ? 'prod'
      : 'test';
    const optimizeId = _.get(
      pageTrackingConfig[this.props.country],
      `googleOptimize.${env}`,
    );

    const googlePageHidingSnippet = `(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
      h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
      (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
    })(window,document.documentElement,'async-hide','dataLayer',4000,
      {'${optimizeId}':true});`;

    return optimizeId
      ? <script
          type="text/javascript"
          dangerouslySetInnerHTML={rawMarkup(googlePageHidingSnippet)}
        />
      : null;
  }
}

GooglePageHiding.propTypes = {
  country: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/Page/GooglePageHiding.jsx